export function callUrlFunction(handleDataFetch, id, setState, state) {
  return (fileData) => {
    // fileData comes from uploadFile; if you ever pass Cloudinary's raw widget result, this also supports result.info
    const file = fileData.info || fileData;

    const resolvedType = file.format === "pdf" ? "pdf" : "image";

    handleDataFetch({
      id,
      url: file.url,                 // actual file (raw for pdf, image for images)
      preview_url: file.preview_url, // image thumbnail for pdf, same as url for images
      // embed_url: file.embed_url,     // for inline viewing (pdf only; images same as url)
      // download_url: file.download_url, // for downloads (pdf only; images same as url)
      // type: resolvedType,
      // format: file.format,
      // original_filename: file.original_filename,
    });

    setState({
      ...state,
      fileResult: file.url,           // actual file
      filePreview: file.preview_url,  // thumbnail (jpg) for pdf
      fileEmbed: file.embed_url,      // inline pdf
      fileDownload: file.download_url,// download link
      file_name: file.original_filename,
      file_type: resolvedType,
      loaded: true,
    });
  };
}




